var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from "lit/decorators.js";
import { html, css } from "lit";
import { repeat } from 'lit/directives/repeat.js';
import { classMap } from 'lit/directives/class-map.js';
import { PICPicker, customElement } from '../../Internals';
let PICDatePicker = class PICDatePicker extends PICPicker {
    set data(data) {
        this.startDate = data.startDate;
        this.endDate = data.endDate;
        this.dispDate = data.startDate;
        this.infoText = data.infoText;
        this.mode = data.mode;
        this.firstClick_ = true;
        this.parentRef_ = data.parent;
        this.dispDate = new Date(data.startDate);
        this.changeMonth(0);
        this.requestUpdate();
    }
    setFirstClick(iBool) {
        this.firstClick_ = iBool;
    }
    constructor() {
        super();
        this.dateCandidates = [];
        this.items = [];
        this.weekdays = [];
        this.years = [];
        this.months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
        this.weekdayArr = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        //private closeListener!: EventListener | null;
        this.firstClick_ = true;
        this.show = "hidden";
        this.startDate = new Date(Date.now());
        this.endDate = new Date(Date.now());
        this.infoText = '';
        this.mode = 'single';
    }
    connectedCallback() {
        for (let i = 2010; i < (new Date().getFullYear() + 30); i++) {
            this.years.push(i.toString());
        }
        super.connectedCallback();
        this.weekdays = [
            { id: 0, class: "weekday", val: 'Mo' },
            { id: 1, class: "weekday", val: 'Tu' },
            { id: 2, class: "weekday", val: 'We' },
            { id: 3, class: "weekday", val: 'Th' },
            { id: 4, class: "weekday", val: 'Fr' },
            { id: 5, class: "weekday", val: 'Sa' },
            { id: 6, class: "weekday", val: 'Su' },
        ];
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-datePickerSelectColor: var(--pic-primaryColor);
            --pic-datePickerSelectTextColorDark: var(--pic-onSurfaceHighColor);
            --pic-datePickerSelectTextColorLight: var(--pic-onPrimaryHighColor);
            --pic-datePickerRangeColor: var(--pic-primaryFocusColor);
        }
        .pick-child {
            flex: 1;
            overflow-y: scroll;
            scrollbar-width: none;
        }
        ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
        }
        .item{
            display: flex;
            justify-content: center;
            cursor: pointer
        }
        .selected{
            background: yellow !important;
        }
        .between{
            background: lightyellow !important;
        }
        .end{
            background: yellow !important;
        }
        .clicked{
            background: orange !important;
        }
        .calendarbody {
            width: 30%;
            max-width: 20%;
            min-width: 300px;
            position: absolute;
            height: fit-content;
            top: 42px;
            z-index: 99999;
        }

        .calendarmonth {
            height: 50px;
            min-width: 100%;
            color: black;
            background: var(--headerColor);
            text-align: center;
            position: relative;
        }

        .calendarmonth ul {
            padding: 0;
            margin: 0;
            list-style-type: none;
            height: 100%;
            min-height: 100%;
            max-height: 100%;
        }

        .calendarmonth li {
            background-color: var(--headerColor);
            line-height: 3;
            color: white;
            font-size: 2em;
            text-transform: uppercase;
            letter-spacing: 3px;
            float: left;
            min-height: 100%;
            max-height: 100%;
            min-width: 84%;
            max-width: 84%;
        }

        .calendarmonth p {
            text-align: center;
            min-height: 100%;
            height: 100%;
            max-height: 100%;
            float: left;
            /*display: inline-block;*/
            margin: 0;
            width: 100%;
            min-width: 100%;
            max-width: 100%;
            font-size: 0.5em;
        }

        .calendarcmonth p {
            line-height: 3.3;
        }

        .weekdays,
        .days {
            margin: 0;
            padding: 0;
            list-style-type: none;
            position: relative;
            font-size: 0.8em;
        }

        .weekdays li {
            /*display: inline;*/
            color: #666;
            background: #ddd;
            width: 14.285%;
            float: left;
        }

        .calendarinfo {
            min-height: 20px;
            width: 100%;
            background-color: var(--headerColor);
            top: 100%;
            color: #A9A9A9;
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: right;
            padding-right: 1%;
            font-size: 0.8em;
        }

        .datefields {
            color: black;
            /*display: inline;*/
            max-width: 14.285%;
            width: 14.285%;
            padding-top: 4%;
            padding-bottom: 9%;
            text-align: center;
            background: #eee;
            height: 0px;
            float: left;
            font-size: 0.8em;
        }
        .datefields.start{
            background: darkgray !important;
        }
        .greydatefields {
            color: grey;
        }

        .datefields.today {
            background-color: #F6F6F6;
        }

        .datefields:hover {
            background-color: var(--buttonHoverColor);
            cursor: pointer;
        }

        .calendarmonth li:nth-child(1),
        .calendarmonth li:nth-child(3) {
            background-color: var(--headerColor);
            line-height: 3;
            color: white;
            font-size: 2em;
            text-transform: uppercase;
            letter-spacing: 3px;
            float: left;
            min-height: 100%;
            max-height: 100%;
            max-width: 8%;
            min-width: 8%;
        }

        .calendarnextbtn {
            float: right;
            max-width: 8%;
            min-width: 8%;
        }

        .calendarprevbtn {
            max-width: 8%;
            min-width: 8%;
        }

        .calendarprevbtn p {
            padding-left: 3px;
        }

        .month.btn{
            cursor: pointer;
        }
        /*
        .today {
            background-color: var(--pic-datePickerSelectTextColorLight); 
            border-color: var(--pic-datePickerSelectTextColorDark);
            color: var(--pic-datePickerSelectTextColorDark);
            border-width: 1px;
            border-style: solid;
        }
        .selected {
            background-color: var(--pic-datePickerSelectColor);
            color: var(--pic-datePickerSelectTextColorLight);
        }
        .range {
            background-color: var(--pic-datePickerRangeColor);
        }
        .rangeleft{

        }
        .rangemid {

        }
        .rangeright {

        }
        .rangedrag{

        }*/
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
        return;
    }
    validateSubmit() {
        return true;
    }
    /*toggle(){
        if(this.show == "show"){
            this.show = "fade";
        } else if(this.show == 'hidden') {
            this.show = 'show';
        };
        this.requestUpdate();
    }*/
    /*handleEnd(e: AnimationEvent){
        if(e.animationName == 'fadeOut'){
            this.show = 'hidden';
            this.requestUpdate();
        }
    }*/
    changeMonth(iVal) {
        var _a;
        if (!this.dispDate)
            return;
        this.dispDate.setDate(1);
        this.dispDate.setMonth(this.dispDate.getMonth() + iVal);
        this.startDate.setHours(0, 0, 0, 0);
        (_a = this.endDate) === null || _a === void 0 ? void 0 : _a.setHours(0, 0, 0, 0);
        let m = this.dispDate.getMonth() + 1;
        let y = this.dispDate.getFullYear();
        let days = m === 2 ? y & 3 || !(y % 25) && y & 15 ? 28 : 29 : 30 + (m + (m >> 3) & 1);
        var firstDayOfMonth = new Date(y, m - 1, 1);
        var lastDayOfMonth = new Date(y, m, 0);
        var prevLastDayOfMonth = new Date(y, m - 1, 0);
        var firstDayOfMonthStr = firstDayOfMonth.toString();
        var weekdayNameIndexFirst = this.weekdayArr.indexOf(firstDayOfMonthStr.substring(0, 3));
        var prevLastDayOfMonthStr = prevLastDayOfMonth.toString();
        var prevLastDayInMonth = prevLastDayOfMonthStr.substring(8, 10);
        if (weekdayNameIndexFirst < 0) {
            weekdayNameIndexFirst = 6;
        }
        if (prevLastDayInMonth.substring(0, 1) == '0') {
            prevLastDayInMonth = prevLastDayInMonth.replace('0', "");
        }
        this.items = [];
        let correctionValFirst = weekdayNameIndexFirst;
        /* days of prev month */
        for (let i = 1; i <= correctionValFirst; i++) {
            let tmpText = (i + (parseInt(prevLastDayInMonth) - correctionValFirst)) + '';
            let tmpId;
            if (m == 1)
                tmpId = (y - 1) + '/12/' + tmpText;
            else
                tmpId = y + '/' + (m - 1) + '/' + tmpText;
            this.items.push({
                id: tmpId,
                text: tmpText,
                class: 'greydatefields',
                mark: this.getMark(tmpId)
            });
        }
        /* days in cur month */
        for (let i = 1; i <= days; i++) {
            let tmpId = y + '/' + (m) + '/' + i;
            this.items.push({
                id: tmpId,
                text: i + '',
                class: '',
                mark: this.getMark(tmpId)
            });
        }
        var lastDayOfMonthStr = lastDayOfMonth.toString();
        var weekdayNameIndexLast = this.weekdayArr.indexOf(lastDayOfMonthStr.substring(0, 3));
        if (weekdayNameIndexLast < 0) {
            weekdayNameIndexLast = 6;
        }
        weekdayNameIndexLast = (6 - weekdayNameIndexLast);
        var currentVals = weekdayNameIndexFirst + days + weekdayNameIndexLast;
        if (currentVals < 42) {
            var difference = 42 - currentVals;
            weekdayNameIndexLast = weekdayNameIndexLast + difference;
        }
        var correctionValLast = weekdayNameIndexLast;
        /* days in next month */
        for (let i = 1; i <= correctionValLast; i++) {
            let tmpId;
            if (m == 12)
                tmpId = (y + 1) + '/01/' + i;
            else
                tmpId = y + '/' + (m + 1) + '/' + i;
            this.items.push({
                id: tmpId,
                text: i + '',
                class: 'greydatefields',
                mark: this.getMark(tmpId)
            });
        }
        this.requestUpdate();
    }
    getMark(iStr) {
        var _a, _b;
        let compDate = new Date(iStr).setHours(0, 0, 0, 0);
        if (compDate == this.startDate.setHours(0, 0, 0, 0))
            return 'selected';
        if (this.endDate)
            if (compDate == this.endDate.setHours(0, 0, 0, 0))
                return 'end';
        if (this.dateCandidates) {
            if (this.dateCandidates.length > 0 && ((_a = this.dateCandidates[0]) === null || _a === void 0 ? void 0 : _a.setHours(0, 0, 0, 0)) == compDate)
                return 'clicked';
            if (this.dateCandidates.length == 2 && ((_b = this.dateCandidates[1]) === null || _b === void 0 ? void 0 : _b.setHours(0, 0, 0, 0)) == compDate)
                return 'clicked';
        }
        if (compDate == new Date(Date.now()).setHours(0, 0, 0, 0))
            return 'today';
        if (this.startDate.setHours(0, 0, 0, 0) < compDate && (this.endDate && this.endDate.setHours(0, 0, 0, 0) > compDate))
            return 'between';
        return '';
    }
    selectDate(iStr, e) {
        let clickedDate = new Date(iStr);
        if (this.mode == 'dual') {
            if (this.dateCandidates.length == 2) {
                this.dateCandidates = [];
            }
            this.dateCandidates.push(clickedDate);
            this.changeMonth(0);
            if (this.dateCandidates.length == 2) {
                this.dateCandidates.sort((a, b) => { return a.valueOf() - b.valueOf(); });
                this.startDate = this.dateCandidates[0];
                this.endDate = this.dateCandidates[1];
                this.changeMonth(0);
                let bubbleevent = { detail: { dates: this.dateCandidates, clickEvent: e }, bubbles: true, composed: true };
                this.dispatchEvent(new CustomEvent('valueselected', bubbleevent));
            }
        }
        else {
            if (!this.firstClick_) {
                if (clickedDate.setHours(0, 0, 0, 0) < this.startDate.setHours(0, 0, 0, 0)) {
                    return;
                }
            }
            this.startDate = clickedDate;
            let tmp = { detail: { firstClick: this.firstClick_, date: clickedDate, clickEvent: e }, bubbles: true, composed: true };
            this.firstClick_ = !this.firstClick_;
            this.changeMonth(0);
            this.dispatchEvent(new CustomEvent('valueselected', tmp));
        }
    }
    render() {
        let classes = {
            picker: true,
            calendarbody: true,
            show: this.show == 'show',
            hidden: this.show == 'hidden',
            fade: this.show == 'fade'
        };
        if (!this.dispDate)
            return html ``;
        return html `
        ${this.renderCSS(true)}
        <div 
            class=${classMap(classes)} 
            @click=${(e) => { this.shouldHide = false; }} 
            @animationend=${this.handleEnd}>
            <div class="calendarmonth">
                <ul>
                    <li class="month btn" @click=${() => { this.changeMonth(-1); }}><p>‹</p></li>
                    <li class="calendarcmonth"><p>${this.months[this.dispDate.getMonth()] + ' ' + this.dispDate.getFullYear()}</p></li>
                    <li class="month btn" @click=${() => { this.changeMonth(1); }}><p>›</p></li>
                </ul>
            </div>
            <ul class="weekdays">
                ${repeat(this.weekdays, (weekday) => weekday.id, (item, index) => html `<li class="${index}" id="${item.id}"><p>${item.val}</p></li>`)}
            </ul>
            <ul class="days">
                ${repeat(this.items, (item) => item.id, (item, index) => html `
                        <li @click=${(e) => { this.selectDate(item.id, e); }} 
                            class="datefields${item.class ? ' ' + item.class : ''}${item.mark ? ' ' + item.mark : ''}">
                            ${item.text}
                        </li>
                    `)}
            </ul>
            <div class="calendarinfo">${this.infoText}</div>
        </div>
        `;
    }
};
__decorate([
    property()
], PICDatePicker.prototype, "show", void 0);
PICDatePicker = __decorate([
    customElement('pic-datepicker')
], PICDatePicker);
export { PICDatePicker };
//# sourceMappingURL=PICDatePicker.js.map